import axios from 'axios'
import { getToken ,clearToken  } from './auth'

import { showMessage } from '@/config/message'

const joinUrl = (base = '', path = '') => {
  const trimmedBase = String(base || '').trim()
  const trimmedPath = String(path || '').trim()
  if (!trimmedBase && !trimmedPath) return ''
  if (!trimmedBase) return trimmedPath
  if (!trimmedPath) return trimmedBase
  if (/^https?:\/\//i.test(trimmedPath)) return trimmedPath
  return `${trimmedBase.replace(/\/+$/, '')}/${trimmedPath.replace(/^\/+/, '')}`
}

const baseUrl = process.env.NODE_ENV === 'development'
  ? ''
  : joinUrl(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_API_URL)

const service = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

const NETWORK_ERROR = 'Network error, please contact the developer'

service.interceptors.request.use(
  (config) => {
	//token
    const token = getToken()
	 
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`  // 添加 Bearer 前缀
	  
    }
    return config
  },
)

service.interceptors.response.use(
  (response) => {
	 
    const { data, config } = response
    if (!data) {
      return Promise.reject(new Error(NETWORK_ERROR))
    }
    if (config && config.rawResponse) {
      return data
    }
    if (data.code === 401) {
      const msg = data.Message || NETWORK_ERROR
      clearToken()
      showMessage(msg, 'error')
      return Promise.reject(new Error(msg))
    }
    if (data.code === 405) {
      const msg = "请求方法错误"
      showMessage(msg, 'error')
      return Promise.reject(new Error(msg))
    }
    if (Object.prototype.hasOwnProperty.call(data, 'retCode')) {
      if (data.retCode === 1) {
        return data.result
      }
	   
      const msg = data.retMsg || NETWORK_ERROR
      showMessage(msg, 'error')
      return Promise.reject(new Error(msg))
    }
    return data
  },
  (error) => {
    const response = error && error.response ? error.response : null
    if (response && response.status) {
      const data = response.data || {}
      const msg = data.Message || data.message || NETWORK_ERROR
      if (response.status === 401) {
        clearToken()  // 清除失效的 token
      }
      showMessage(msg, 'error')
    }
    return Promise.reject(error)
  }
)

export { service, baseUrl }
export default service
